// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.loadingScreen[data-v-18eab050] {\n  height: 100vh;\n}\n.loadingIndicator[data-v-18eab050] {\n  width: 500px;\n  height: 150px;\n  box-sizing: content-box;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
